// src/features/tasks/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import TasksListPage from './pages/TasksListPage';
import TaskCategoriesPage from './pages/TaskCategoriesPage';
import TaskDetailsPage from './pages/TaskDetailsPage';
import CreateTaskPage from './pages/CreateTaskPage';
import EditTaskPage from './pages/EditTaskPage';
import CalendarPage from './pages/CalendarPage';
import TeamCalendarPage from './pages/TeamCalendarPage';
import TaskCatalogPage from './pages/TaskCatalog';

export const TaskRoutes = () => (
  <>
    <Route path="tasks">
      <Route
        index
        element={
          <ProtectedRoute requiredScope="task:read">
            <TasksListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute requiredScope="task:create">
            <CreateTaskPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="catalog"
        element={
          <ProtectedRoute requiredScope="task:create">
            <TaskCatalogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":taskId/edit"
        element={
          <ProtectedRoute requiredScope="task:update">
            <EditTaskPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":taskId"
        element={
          <ProtectedRoute requiredScope="task:read">
            <TaskDetailsPage />
          </ProtectedRoute>
        }
      />
    </Route>
    <Route
      path="calendar"
      element={
        <ProtectedRoute requiredScope="task:read">
          <CalendarPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="team-calendar"
      element={
        <ProtectedRoute requiredScope="task:read">
          <TeamCalendarPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="categories"
      element={
        <ProtectedRoute requiredScope="task-category:read">
          <TaskCategoriesPage />
        </ProtectedRoute>
      }
    />
  </>
);